import {useEffect, useState} from 'react';
import {useRouter} from "next/router";
import {useForm} from "react-hook-form";
import useTranslation from "next-translate/useTranslation";
import cn from 'classnames';
import {IPaginator} from "@lib/dto/IPaginator";


export default function Paginator(paginator: IPaginator) {
    const { t } = useTranslation('common');
    const router = useRouter();

    const goToPage = async (page: number) => {
        if (page === 1) {
            delete router.query.page
        } else {
            router.query.page = page.toString();
        }
        await router.push(router);
    }

    return (
        <div className="more-btn">
            {(paginator?.pageCount !== undefined && paginator?.pageCount > 1) && <div className="pagination">
                {paginator.page > 1 && <a href={"#"} onClick={(e) => { e.preventDefault(); goToPage(paginator.page - 1) }} className="prev" title="Předchozí" />}
                <a href="#" onClick={(e) => { e.preventDefault(); goToPage(1) }} className={cn({ ['active']: 1 === paginator.page })}>{1}</a>
                {paginator.page-1 > 1 && <a style={{marginLeft: 0, marginRight: -24, border: 'none'}}>...</a>}
                {Array.from(Array(paginator?.pageCount).keys()).map((page: number) => <>
                    {(page > 0 && page+1 < paginator.pageCount && page+1 >= paginator.page-1 && (page < paginator.page + (paginator.page == 1 ? 2 : 1)) )&& <a href="#" onClick={(e) => { e.preventDefault(); goToPage(page + 1) }} className={cn({ ['active']: (page + 1) === paginator.page })}>{page+1}</a>}
                </>)}

                {paginator.page+2 < paginator.pageCount && <a style={{marginLeft: 0, marginRight: -24, border: 'none'}}>...</a>}
                <a href="#" onClick={(e) => { e.preventDefault(); goToPage(paginator.pageCount) }} className={cn({ ['active']: (paginator.pageCount) === paginator.page })}>{paginator.pageCount}</a>
                {paginator.page < paginator.pageCount && <a href={"#"} onClick={(e) => { e.preventDefault(); goToPage(paginator.page + 1) }}  className="next" title="Další" />}
            </div>}
        </div>
    );

    /*<div className="more-btn">
                        <a href="" className="btn">
                            {t("Načíst další")}
                        </a>
                        <div className="pagination">
                            <a href="" className="prev" title={t("Předchozí")}>

                            </a>
                            <a href="">
                                1
                            </a>
                            <a href="" className="active">
                                2
                            </a>
                            <a href="">
                                3
                            </a>
                            <a href="" className="next" title={t("Další")}>

                            </a>
                        </div>
                    </div>*/
}
